import { render } from "./UserIcon.vue.js?vue&type=template&id=0cf41946!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./UserIcon.vue?vue&type=template&id=0cf41946"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__